var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{staticClass:"mx-4",attrs:{"clearable":false,"show-size":"","multiple":"","accept":".zip,.7z","label":_vm.fileinputlabel,"value":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var index = ref.index;
var text = ref.text;
return [_c('v-chip',{attrs:{"close":""},on:{"click:close":function($event){return _vm.deleteChip(index)}}},[_vm._v("\n        "+_vm._s(text)+"\n        ")])]}}])})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0013008e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/customwidgets/CloseableChipFileInput.vue
// module id = null
// module chunks = 